import { CompaniesPage } from '@/features/companies/pages/companies-page';

const CompaniesRoute = () => {
  return <CompaniesPage />;
};

export default CompaniesRoute;
